/** @format */
import { ChangeDetectionStrategy, Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { Plan } from 'common-typescript/types';
import { UuidService } from 'sis-common';

@Component({
    selector: 'app-plan-header-info-list',
    templateUrl: './plan-header-info-list.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanHeaderInfoListComponent {
    @Input() currentPlan: Plan;

    readonly primaryBadgeId = `primary-plan-badge-${inject(UuidService).randomUUID()}`;
}
